// re.rejouis.fr — DON direct : on offre son jouet, sans estimation ni crédit.
// Deux méthodes : dépôt en point de collecte partenaire (carte maison + liste)
// ou envoi par courrier jusqu'à l'atelier (adresse + point Mondial Relay).
import { useState } from 'react';
import { EcranHeader, Icons, Sticker, Illus } from '../components/ui.jsx';
import { RECEPTION } from '../lib/dons.js';

// Carte personnalisée Google My Maps (éditée côté Google) — intégrée en iframe.
// La carte doit être partagée « Public sur le Web » pour s'afficher.
const MYMAPS_EMBED = 'https://www.google.com/maps/d/embed?mid=1CBOz3J9JvP-W9g1yiaMG_39S0OMstbE';

export default function Don({ go }) {
  const [methode, setMethode] = useState('collecte'); // collecte | courrier
  const [copie, setCopie] = useState(null); // 'atelier' | 'relais' | null

  const adresseAtelier = RECEPTION.nom + '\n' + RECEPTION.adresse + '\n' + RECEPTION.cp_ville;
  const adresseRelais = RECEPTION.relais_nom + ' (' + RECEPTION.relais_code + ')\n' + RECEPTION.relais_adresse + '\n' + RECEPTION.relais_ville;

  function copier(quoi, texte) {
    try { navigator.clipboard && navigator.clipboard.writeText(texte); } catch { /* clipboard indispo */ }
    setCopie(quoi);
    setTimeout(() => setCopie(null), 1800);
  }

  const tab = (id, label, illus) => (
    <button onClick={() => setMethode(id)} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '12px 6px', borderRadius: 12,
      background: methode === id ? 'var(--blanc)' : 'transparent', boxShadow: methode === id ? 'var(--shadow-card)' : 'none',
      color: methode === id ? 'var(--noir)' : 'var(--stone)', fontWeight: 600, fontSize: 12.5 }}>
      <span style={{ opacity: methode === id ? 1 : 0.55 }}><Illus nom={illus} size={30} /></span> {label}
    </button>
  );

  return (
    <div className="no-scrollbar" style={{ height: '100%', overflow: 'auto', padding: '0 0 40px' }}>
      <EcranHeader titre="Faire un don" onBack={() => go('accueil')} />

      <div style={{ padding: '0 18px' }}>
        <div className="soft-card" style={{ padding: '14px 16px', display: 'flex', gap: 12, alignItems: 'center' }}>
          <Sticker nom="mains-coeur" size={56} rot={-6} />
          <div style={{ fontSize: 13, lineHeight: 1.55 }}>
            Pas envie de t’embêter avec une estimation ? <strong>Donne-le, c’est tout.</strong> Pas de formulaire, pas de crédit : on le désinfecte, on le reconditionne et on lui trouve une seconde vie.
            <div style={{ marginTop: 6 }}>Tu as une demande de reprise en cours&nbsp;? Le plus simple&nbsp;: glisse tes dons dans son colis, avec un petit mot «&nbsp;DON&nbsp;».</div>
          </div>
        </div>

        {/* Sélecteur de méthode */}
        <div style={{ display: 'flex', gap: 4, background: 'var(--stone-pale)', borderRadius: 14, padding: 4, margin: '16px 0 4px' }}>
          {tab('collecte', 'Point de collecte', 'relais')}
          {tab('courrier', 'Par courrier', 'camion')}
        </div>
      </div>

      {methode === 'collecte' ? (
        <div>
          {/* Carte des points de collecte (Google My Maps) */}
          <div style={{ padding: '12px 18px 0' }}>
            <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
              <iframe
                src={MYMAPS_EMBED}
                title="Points de collecte Rejouis"
                style={{ width: '100%', height: 440, border: 0, display: 'block' }}
                loading="lazy"
              />
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--stone)', textAlign: 'center', marginTop: 8 }}>
              Touche un point sur la carte pour voir l’adresse et les horaires
            </div>
          </div>
        </div>
      ) : (
        <div style={{ padding: '12px 18px 0' }}>
          <div className="soft-card" style={{ padding: '12px 14px', display: 'flex', gap: 10, alignItems: 'center', marginBottom: 14 }}>
            <Illus nom="camion" size={34} />
            <div style={{ fontSize: 12.5, lineHeight: 1.5 }}>Quand tu veux, sans prévenir : un don spontané par Mondial Relay (ou La Poste) jusqu’à notre atelier.</div>
          </div>

          {/* Consignes d'envoi — mises en avant avant les adresses */}
          <div style={{ padding: 16, borderRadius: 'var(--r-card)', background: 'var(--rouge-pale)', border: '1px solid rgba(242,68,68,0.22)', marginBottom: 18 }}>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12 }}>Avant d’envoyer ton colis</div>
            {[
              { illus: 'propre', t: 'Nettoie ton jouet', s: 'Il doit arriver propre : on s’occupe ensuite de le désinfecter.' },
              { illus: 'lot', t: 'Un carton solide, jouet bien calé', s: 'Remplis les vides (papier, papier bulle) pour qu’il ne bouge pas pendant le transport.' },
            ].map(({ illus, t, s }, i) => (
              <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', marginTop: i ? 12 : 0 }}>
                <Illus nom={illus} size={40} />
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14 }}>{t}</div>
                  <div style={{ fontSize: 12.5, color: 'var(--encre-doux)', lineHeight: 1.45, marginTop: 1 }}>{s}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="t-overline" style={{ marginBottom: 8 }}>Adresse de l’atelier</div>
          <div className="card" style={{ padding: 18 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <Illus nom="lot" size={44} />
              <div style={{ flex: 1, fontSize: 14, lineHeight: 1.55 }}>
                <div style={{ fontWeight: 700 }}>{RECEPTION.nom}</div>
                <div style={{ color: 'var(--encre-doux)' }}>{RECEPTION.adresse}</div>
                <div style={{ color: 'var(--encre-doux)' }}>{RECEPTION.cp_ville}</div>
              </div>
            </div>
            <button className="btn btn-secondary btn-block" style={{ marginTop: 14 }} onClick={() => copier('atelier', adresseAtelier)}>
              {copie === 'atelier' ? <><Icons.check size={16} sw={2.2} /> Adresse copiée</> : <><Icons.pencil size={15} /> Copier l’adresse</>}
            </button>
          </div>

          <div className="t-overline" style={{ margin: '18px 0 8px' }}>Point Mondial Relay</div>
          <div className="card" style={{ padding: 18 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
              <Illus nom="relais" size={44} />
              <div style={{ flex: 1, fontSize: 14, lineHeight: 1.55 }}>
                <div style={{ fontWeight: 700 }}>{RECEPTION.relais_nom}</div>
                <div style={{ color: 'var(--encre-doux)' }}>{RECEPTION.relais_adresse}</div>
                <div style={{ color: 'var(--encre-doux)' }}>{RECEPTION.relais_ville}</div>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginTop: 12, padding: '10px 12px', borderRadius: 10, background: 'var(--creme)' }}>
              <span style={{ fontSize: 12.5, color: 'var(--encre-doux)' }}>Code Point Relais</span>
              <span className="mono" style={{ fontWeight: 700, fontSize: 15 }}>{RECEPTION.relais_code}</span>
            </div>
            <button className="btn btn-secondary btn-block" style={{ marginTop: 12 }} onClick={() => copier('relais', adresseRelais)}>
              {copie === 'relais' ? <><Icons.check size={16} sw={2.2} /> Adresse copiée</> : <><Icons.pencil size={15} /> Copier l’adresse et le code</>}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
